import { segmentize } from './segmentize';

export const getVersionedPath = (
  key: string,
  slug: string,
  defaultVersion?: string,
  version?: string,
  hasPlatforms?: boolean,
): string => {
  // determine if the version needs to be added first or after the platform
  const index = hasPlatforms ? 1 : 0;

  const path = segmentize(slug);
  // add the version
  if (version === defaultVersion && key !== defaultVersion) {
    path.splice(index, 0, key);
    // remove the version if we switch back to the default version
  } else if (key === defaultVersion && version !== defaultVersion) {
    path.splice(index, 1);
  } else if (key !== defaultVersion) {
    path.splice(index, 1, key);
  }

  return path.join('/');
};
